export { isFlexibleProcessWorkflow as isFlexibleProduct } from "./productProcessMigrationUtils";

export function mongoIdForProductUpdate(
  form: { id?: string } | null | undefined,
  locationState?: { productDetails?: { _id?: string } } | null
): string {
  const fromForm = String(form?.id || "").trim();
  if (fromForm) {
    return fromForm;
  }
  return String(locationState?.productDetails?._id || "").trim();
}

export function newProductProcessId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `pp-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
